import { render, staticRenderFns } from "./GroupViewContent.vue?vue&type=template&id=25aebed0&scoped=true&"
import script from "./GroupViewContent.vue?vue&type=script&lang=js&"
export * from "./GroupViewContent.vue?vue&type=script&lang=js&"
import style0 from "./GroupViewContent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GroupViewContent.vue?vue&type=style&index=1&id=25aebed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aebed0",
  null
  
)

export default component.exports